import { useExtensionsSetupRegistryForPatient } from '../../../hooks/useExtensions/useExtensionsSetupRegistry';
import { useSideloadSyncForPatient } from '../../../hooks/useExtensions/useSideloadSync/useSideloadSyncForPatient';

export function ExtensionsMainPatient(): null {
  useExtensionsSetupRegistryForPatient();
  useSideloadSyncForPatient();
  return null;
}
